/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogRef,
  CatalogRefOptional,
  CatalogRefMetaI,
  CatalogRefTrackedI,
} from "./catalog-ref";
import { CatalogRefTracked, CatalogRefMeta } from "./catalog-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DateRangeActivated,
  DateRangeActivatedOptional,
  DateRangeActivatedMetaI,
  DateRangeActivatedTrackedI,
} from "./date-range-activated";
import {
  DateRangeActivatedTracked,
  DateRangeActivatedMeta,
} from "./date-range-activated";

/**
 *
 * @export
 * @interface CatalogBase
 */
export interface CatalogBaseOptional extends CatalogRefOptional {
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogBase
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  catalogName?: string;
}

export interface CatalogBase
  extends CatalogBaseOptional, CatalogRef, DateRangeActivated {
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogBase
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  catalogName?: string;
}

export interface CatalogBaseTrackedI extends CatalogRefOptional {
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogBase
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogBase
   */
  catalogName?: string;
  catalogNameIsSet: boolean;
}

transformDatesMap.set("CatalogBase", function (model: CatalogBase) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
});

export type CatalogBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  catalogName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var CatalogBaseMeta: CatalogBaseMetaI = {} as CatalogBaseMetaI;
CatalogBaseMeta = typeMeta("CatalogBase", {
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  catalogName: propertyMeta(
    "catalogName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = CatalogBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DateRangeActivatedMeta]);
  metaI.startActive.inheritedFrom = DateRangeActivatedMeta.startActive;
  metaI.endActive.inheritedFrom = DateRangeActivatedMeta.endActive;
  metaI.interfaces = metaI.interfaces.concat([CatalogRefMeta]);
  metaI.assignId.inheritedFrom = CatalogRefMeta.assignId;
});

export class CatalogBaseTracked
  extends CatalogRefTracked
  implements CatalogBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  catalogName__I?: string = undefined;
  catalogNameIsSet: boolean = false;
  set catalogName(v: undefined | string) {
    if (v !== undefined) {
      this.catalogName__I = v;
      this.catalogNameIsSet = true;
    } else {
      this.catalogName__I = v || undefined;
      this.catalogNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogName() {
    return this.catalogName__I;
  }
  constructor(config?: CatalogBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: CatalogBaseOptional,
    options?: AssignOptions,
  ): CatalogBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.catalogName &&
      this.catalogNameApplyFilter(optionsRequired.filter)
    ) {
      this.catalogName = config.catalogName;
      if (optionsRequired.unassign) this.catalogNameIsSet = false;
      else this.catalogNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogBaseTrackedI {
    const cloned = {} as CatalogBaseTrackedI;
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.catalogNameIsSetDeep() &&
      this.catalogNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogNameIsSet = true;
      cloned.catalogName = this.catalogName;
    } else {
      //cloned.catalogNameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogBaseTrackedI {
    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.catalogNameApplyFilter(filter)) this.catalogNameIsSet = false;

    return this;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogBaseMeta.startActive,
      CatalogBaseMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogBaseMeta.endActive,
      CatalogBaseMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogBaseMeta.assignId,
      CatalogBaseMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  catalogNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogBaseMeta.catalogName,
      CatalogBaseMeta,
      this.catalogName,
      this,
    );
  }
  catalogNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.catalogNameIsSet && this.catalogNameApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.catalogNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
